import { useContext } from 'react';
import { ModalContext, Modals } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchCheckout } from 'Containers/Plans/hooks';
import { createURL } from 'Containers/Plans/utils';
import { BodyObject } from 'Containers/Plans/components/CardPlan/types';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';

const SaveCardModal = ({
  successUrl,
  cancelUrl,
  checkoutParams,
}: {
  successUrl: string;
  cancelUrl: string;
  checkoutParams: {
    filing: string;
    plans: string;
    fromFedUser?: string;
    submitFlex?: string;
    saveCard?: string;
    submitFlexLite?: string;
    isExtendedFlexLite?: string;
    isExtendedAndIsToReturn?: string;
  };
}): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const { mutate } = useFetchCheckout();
  const { hideModal } = useContext(ModalContext);
  const saveCardSuccessUrl = createURL(successUrl, checkoutParams);
  const saveCardCancelUrl = createURL(cancelUrl);
  const handleClick = (): void => {
    const body: BodyObject = {
      checkoutConfig: {
        successUrl: saveCardSuccessUrl,
        cancelUrl: saveCardCancelUrl,
        paymentMethod: 'card',
      },
      type: 'setup',
    };
    EventService.saveCardSessionStarted();
    mutate(body);
  };
  const isFlexLite = checkoutParams.submitFlexLite === 'true';
  return (
    <Modals.Centered
      maxSize="S"
      urlImage={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/colored/addcard_s.png`}
      title={t('SaveCardModal.title')}
      subtitle={t('SaveCardModal.subtitle')}
      description={t('SaveCardModal.description', {
        context: isFlexLite && 'flexLite',
      })}
      primaryButton={{
        label: t('SaveCardModal.primaryButton'),
        onClick: handleClick,
      }}
      hasClose
      onClose={hideModal}
      buttonsAlign="center"
    />
  );
};

export default SaveCardModal;
